import { api } from '../api/client';

/**
 * GET /api/status — what keepr is running and whether it is up (KPR-319,
 * keepr-api SCHEMA.md "Public status"). Public, no credentials, cached for up
 * to a minute:
 *
 *   { status: 'ok' | 'degraded' | 'down', checkedAt,
 *     components: [{ id, name, version: string | null, status }] }
 *
 * The body is the verdict and the response is always 200, so a rejected
 * request here means keepr's API could not be reached at all. Read it with
 * normalizeStatus (utils/status.js), which accepts only the shape above.
 */
export async function getStatus() {
	const { data } = await api.get('/status', { timeout: 10000 });
	return data;
}

export default getStatus;
